import React from 'react'
import { DateTime } from 'luxon'
import { Trans, useTranslation } from 'react-i18next'
import { FreeParkingCardContainer } from '@components/ParkingCard/ParkingCard.style'
import FormPlateInput from 'parkdepot-shared/components/LPInput'
import { Icon, Subtitle, Time, Title } from '../CarpayOrderCard.style'

interface Props {
    end_date: string
    plate: string
    country: string
}

const FreeOrderCard = ({ end_date, plate, country }: Props) => {
    const now = DateTime.now()
    const endDate = DateTime.fromISO(end_date)
    const { t } = useTranslation()

    const relativeTime = endDate?.toRelativeCalendar({ unit: 'days' })

    return (
        <FreeParkingCardContainer>
            <Icon className="wemolo-check-circle" />
            <Title>{t('carpay.notFound.overview.freeParking')}</Title>
            <Subtitle>
                <div>{t('carpay.notFound.overview.yourTicket')}</div>
                <div>
                    <Trans i18nKey="carpay.notFound.overview.validUntil">
                        {{
                            end_time: endDate.toFormat('HH:mm'),
                            day: relativeTime
                        }}
                    </Trans>
                </div>
            </Subtitle>
            <div>
                <FormPlateInput disabled readOnly value={plate} country={country} />
                <Time>{now.toFormat('dd.MM.yyyy HH:mm')}</Time>
            </div>
        </FreeParkingCardContainer>
    )
}

export default FreeOrderCard
